import {ValueObject} from '@s-ui/domain'

export class GetMessagingProviderTokenUserValueObject extends ValueObject {
  #messagingProviderToken

  /**
   * @param {String} token
   * */
  static create({token}) {
    return new GetMessagingProviderTokenUserValueObject({token})
  }

  constructor({token}) {
    super()
    this.#messagingProviderToken = token
  }

  toJSON() {
    return {
      messagingProviderToken: this.#messagingProviderToken
    }
  }
}
